/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
  "data": {
    "day": {
      "-1": "jiya",
      "0": "yau",
      "1": "gobe",
      "future": {
        "one": "a cikin kwanaki {0}",
        "other": "a cikin kwanaki {0}"
      },
      "past": {
        "one": "kwana {0} da ya gabata",
        "other": "kwanaki {0} da suka gabata"
      }
    },
    "day-narrow": {
      "-1": "jiya",
      "0": "yau",
      "1": "gobe",
      "future": {
        "one": "a cikin kwanaki {0}",
        "other": "a cikin kwanaki {0}"
      },
      "past": {
        "one": "kwana {0} da ya gabata",
        "other": "kwanaki {0} da suka gabata"
      }
    },
    "day-short": {
      "-1": "jiya",
      "0": "yau",
      "1": "gobe",
      "future": {
        "one": "a cikin kwanaki {0}",
        "other": "a cikin kwanaki {0}"
      },
      "past": {
        "one": "kwana {0} da ya gabata",
        "other": "kwanaki {0} da suka gabata"
      }
    },
    "hour": {
      "0": "wannan awa",
      "future": {
        "one": "cikin awa {0}",
        "other": "cikin awanni {0}"
      },
      "past": {
        "one": "awa {0} da ta gabata",
        "other": "awanni {0} da suka gabata"
      }
    },
    "hour-narrow": {
      "0": "wannan awa",
      "future": {
        "one": "cikin awa {0}",
        "other": "cikin awanni {0}"
      },
      "past": {
        "one": "awa {0} da ta gabata",
        "other": "awanni {0} da suka gabata"
      }
    },
    "hour-short": {
      "0": "wannan awa",
      "future": {
        "one": "cikin awa {0}",
        "other": "cikin awanni {0}"
      },
      "past": {
        "one": "awa {0} da ta gabata",
        "other": "awanni {0} da suka gabata"
      }
    },
    "minute": {
      "0": "wannan mintin",
      "future": {
        "one": "cikin minti {0}",
        "other": "cikin mintuna {0}"
      },
      "past": {
        "one": "minti {0} da ya gabata",
        "other": "mintuna {0} da suka gabata"
      }
    },
    "minute-narrow": {
      "0": "wannan mintin",
      "future": {
        "one": "cikin minti {0}",
        "other": "cikin mintuna {0}"
      },
      "past": {
        "one": "minti {0} da ya gabata",
        "other": "mintuna {0} da suka gabata"
      }
    },
    "minute-short": {
      "0": "wannan mintin",
      "future": {
        "one": "cikin minti {0}",
        "other": "cikin mintuna {0}"
      },
      "past": {
        "one": "minti {0} da ya gabata",
        "other": "mintuna {0} da suka gabata"
      }
    },
    "month": {
      "-1": "watan da ya gabata",
      "0": "wannan watan",
      "1": "wata na gaba",
      "future": {
        "one": "a cikin watan {0}",
        "other": "a cikin watanni {0}"
      },
      "past": {
        "one": "wata {0} da ya gabata",
        "other": "watanni {0} da suka gabata"
      }
    },
    "month-narrow": {
      "-1": "watan da ya gabata",
      "0": "wannan watan",
      "1": "wata na gaba",
      "future": {
        "one": "a cikin watan {0}",
        "other": "a cikin watan {0}"
      },
      "past": {
        "one": "wata {0} da ya gabata",
        "other": "watanni {0} da suka gabata"
      }
    },
    "month-short": {
      "-1": "watan da ya gabata",
      "0": "wannan watan",
      "1": "wata na gaba",
      "future": {
        "one": "a cikin watan {0}",
        "other": "a cikin watan {0}"
      },
      "past": {
        "one": "wata {0} da ya gabata",
        "other": "watanni {0} da suka gabata"
      }
    },
    "nu": [
      "latn"
    ],
    "quarter": {
      "-1": "kwatan karshe",
      "0": "wannan kwatan",
      "1": "kwata na gaba",
      "future": {
        "one": "a cikin kwata {0}",
        "other": "a cikin kwatas {0}"
      },
      "past": {
        "one": "kwata {0} da suka gabata",
        "other": "kwata {0} da suka gabata"
      }
    },
    "quarter-narrow": {
      "-1": "kwatan karshe",
      "0": "wannan kwatan",
      "1": "kwata na gaba",
      "future": {
        "one": "a cikin kwata {0}",
        "other": "a cikin kwatas {0}"
      },
      "past": {
        "one": "kwata {0} da suka gabata",
        "other": "kwata {0} da suka gabata"
      }
    },
    "quarter-short": {
      "-1": "kwatan karshe",
      "0": "wannan kwatan",
      "1": "kwata na gaba",
      "future": {
        "one": "a cikin kwata {0}",
        "other": "a cikin kwatas {0}"
      },
      "past": {
        "one": "kwata {0} da suka gabata",
        "other": "kwata {0} da suka gabata"
      }
    },
    "second": {
      "0": "yanzu",
      "future": {
        "one": "cikin dakika {0}",
        "other": "cikin dakiku {0}"
      },
      "past": {
        "one": "dakika {0} da ta gabata",
        "other": "dakiku {0} da suka gabata"
      }
    },
    "second-narrow": {
      "0": "yanzu",
      "future": {
        "one": "cikin dakika {0}",
        "other": "cikin dakiku {0}"
      },
      "past": {
        "one": "dakika {0} da ta gabata",
        "other": "dakiku {0} da suka gabata"
      }
    },
    "second-short": {
      "0": "yanzu",
      "future": {
        "one": "cikin dakika {0}",
        "other": "cikin dakiku {0}"
      },
      "past": {
        "one": "dakika {0} da ta gabata",
        "other": "dakiku {0} da suka gabata"
      }
    },
    "week": {
      "-1": "satin da ya gabata",
      "0": "wannan satin",
      "1": "sati na gaba",
      "future": {
        "one": "a cikin mako {0}",
        "other": "a cikin makonni {0}"
      },
      "past": {
        "one": "mako {0} da ya gabata",
        "other": "makonni {0} da suka gabata"
      }
    },
    "week-narrow": {
      "-1": "satin da ya gabata",
      "0": "wannan satin",
      "1": "sati na gaba",
      "future": {
        "one": "a cikin mako {0}",
        "other": "a cikin makonni {0}"
      },
      "past": {
        "one": "mako {0} da ya gabata",
        "other": "mako {0} da ya gabata"
      }
    },
    "week-short": {
      "-1": "satin da ya gabata",
      "0": "wannan satin",
      "1": "sati na gaba",
      "future": {
        "one": "a cikin mako {0}",
        "other": "a cikin makonni {0}"
      },
      "past": {
        "one": "mako {0} da ya gabata",
        "other": "makonni {0} da suka gabata"
      }
    },
    "year": {
      "-1": "bara",
      "0": "bana",
      "1": "badi",
      "future": {
        "one": "a shekarar {0}",
        "other": "a shekaru {0}"
      },
      "past": {
        "one": "shekara {0} da ta gabata",
        "other": "shekaru {0} da suka gabata"
      }
    },
    "year-narrow": {
      "-1": "bara",
      "0": "bana",
      "1": "badi",
      "future": {
        "one": "a shekarar {0}",
        "other": "a shekaru {0}"
      },
      "past": {
        "one": "shekara {0} da ta gabata",
        "other": "shekaru {0} da suka gabata"
      }
    },
    "year-short": {
      "-1": "bara",
      "0": "bana",
      "1": "badi",
      "future": {
        "one": "a shekarar {0}",
        "other": "a shekaru {0}"
      },
      "past": {
        "one": "shekara {0} da ta gabata",
        "other": "shekaru {0} da suka gabata"
      }
    }
  },
  "locale": "ha-GH"
})
}
